import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Col, Container, Row, Table } from 'reactstrap';
import CheckIcon from '../../shared/components/custom/CheckIcon';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Loading from '../../shared/components/custom/Loading';
import useModal from '../../shared/hooks/useModal';
import Api from '../../util/api';
import { formatDate } from '../../util/date-and-time';
import { partial } from '../../util/translation/translation';
import FormCard from '../../shared/components/custom/FormCard';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';

const p = partial('chat');
const s = partial('shared');

const ChatListPage = () => {
  const history = useHistory();
  const [chats, setChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(true);
  const [handleModal, visible, deleteID] = useModal();

  const fetchChats = useCallback(async () => {
    setLoadingChats(true);
    try {
      const resChats = await Api.chat.getChats();
      setChats(resChats);
    } catch (err) {
      toast.error(err || p('chatsRetrievingERROR'));
    } finally {
      setLoadingChats(false);
    }
  }, []);

  useEffect(() => {
    fetchChats();
  }, [fetchChats]);

  const deleteChat = async () => {
    setLoadingChats(true);
    try {
      await Api.chat.deleteChat(deleteID);
      toast.success(p('chatDeleted'));
    } catch (err) {
      toast.error(err || p('chatDeletedERROR'));
    } finally {
      handleModal();
      fetchChats();
    }
  };

  const renderChats = () => {
    return chats.map((chat, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`chat-${chat.id}`}
      >
        <td>
          <CheckIcon state={!!chat.isActive} />
        </td>
        <td>
          <Link to={`/chats/edit/${chat.id}`}>{chat.name}</Link>
        </td>
        <td>{chat.description || '-'}</td>
        <td>{chat.createdAt ? formatDate(chat.createdAt) : '-'}</td>
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() => history.push(`/chats/edit/${chat.id}`)}
              title={s('edit')}
              id={`edit-${chat.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => handleModal(chat.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-${chat.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <Container>
      <Loading loading={loadingChats} />
      <DeleteModal
        visible={visible}
        type={p('theChatSmall')}
        handleModal={handleModal}
        modalAction={deleteChat}
      />
      <Row>
        <Col>
          <FormCard
            title={p('chats')}
            actions={
              <Link to="/chats/create">
                <Button size="sm" color="primary" className="mb-0">
                  {s('create')}
                </Button>
              </Link>
            }
            bodyClassName="form-card__body--flush"
            className="mb-3"
          >
            <Table responsive striped className="table--roomy">
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }}>{s('active')}</th>
                  <th style={{ color: '#4D576A' }}>{s('name')}</th>
                  <th style={{ color: '#4D576A' }}>{s('description')}</th>
                  <th style={{ color: '#4D576A' }}>{s('publicationDate')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {chats.length === 0 && !loadingChats ? (
                  <tr>
                    <td colSpan={5} className="text-muted">
                      {p('noChats')}
                    </td>
                  </tr>
                ) : (
                  renderChats()
                )}
              </tbody>
            </Table>
          </FormCard>
        </Col>
      </Row>
    </Container>
  );
};

export default ChatListPage;
